import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_VALIDATE_AGENT_BEGIN,
  MANAGE_SUBS_VALIDATE_AGENT_SUCCESS,
  MANAGE_SUBS_VALIDATE_AGENT_FAILURE,
  MANAGE_SUBS_VALIDATE_AGENT_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function validateAgent(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_VALIDATE_AGENT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/agentValidation?networkId=${args.networkId}`, null, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_VALIDATE_AGENT_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_VALIDATE_AGENT_FAILURE,
            data: { error: errorMsg },
          });
          reject(errorMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissValidateAgentError() {
  return {
    type: MANAGE_SUBS_VALIDATE_AGENT_DISMISS_ERROR,
  };
}

export function useValidateAgent() {
  const dispatch = useDispatch();

  const { validateAgentPending, validateAgentError } = useSelector(
    state => ({
      validateAgentPending: state.manageSubs.validateAgentPending,
      validateAgentError: state.manageSubs.validateAgentError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(validateAgent(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissValidateAgentError());
  }, [dispatch]);

  return {
    validateAgent: boundAction,
    validateAgentPending,
    validateAgentError,
    dismissValidateAgentError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_VALIDATE_AGENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        validateAgentPending: true,
        validateAgentError: null,
      };

    case MANAGE_SUBS_VALIDATE_AGENT_SUCCESS:
      // The request is success
      return {
        ...state,
        validateAgentPending: false,
        validateAgentError: null,
      };

    case MANAGE_SUBS_VALIDATE_AGENT_FAILURE:
      // The request is failed
      return {
        ...state,
        validateAgentPending: false,
        validateAgentError: action.data.error,
      };

    case MANAGE_SUBS_VALIDATE_AGENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        validateAgentError: null,
      };

    default:
      return state;
  }
}
